import { FC, PropsWithChildren } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Icons } from "rujira.ui";

export const Meta = ({
  title,
  description,
}: {
  title: string;
  description: string;
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="og:description" content={description} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export const StrategyContainer: FC<PropsWithChildren> = ({ children }) => {
  return (
    <>
      <div className="rujira__main rujira__main rujira__main--gradient pools">
        <div className="rujira__inner rujira__inner--pad">
          <Link
            to="/strategies"
            className="fs-14 color-grey hover-white no-underline flex ai-c">
            <Icons.ArrowLeft className="w-2 h-a mr-0.5" />
            Back to Strategies
          </Link>
          {children}
        </div>
      </div>
    </>
  );
};

export const AddressLink: FC<{ address: string }> = ({ address }) => {
  const url = address.startsWith("sthor")
    ? `https://stagenet.thorchain.net/address/${address}`
    : `https://thorchain.net/address/${address}`;

  return (
    <a
      target="_blank"
      href={url}
      className="color-white hover-primary1 iflex ai-c">
      {`${address.slice(0, 8)} ... ${address.slice(-12)}`}
      <Icons.External className="w-2 h-2 ml-1" />
    </a>
  );
};
